import {useState} from 'react';
import { 
    Table, 
    TableHeader, 
    TableHeaderCell, 
    TableBody, TableRow, 
    TableCell, 
    TableCellLayout, 
    Button, 
    Tooltip, 
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogTrigger,
    DialogContent,
    useToastController,
  } from "@fluentui/react-components";
import { ChevronLeftRegular, ChevronRightRegular, Info32Filled, Info32Regular } from "@fluentui/react-icons";
import { format, startOfMonth, addMonths, subMonths } from "date-fns";
import { useGlobalStatus } from '../../services/GlobalStatusProvider';
import '../timesheet/Timesheet.css';
import TooltipWatcherWidget from '../TooltipWatcherWidget';
import { useNavigate } from "react-router-dom";
import { ManualDocusignApproval } from '../../services/apiService'
import { showErrorToast, showSuccessToast, TOASTER_ID } from "../../services/toastUtils";


export default function MonthlyTimesheetExternalApprovalStatus({ data, setData, currentMonthStart, setCurrentMonthStart }) {
  const { startLoad, endLoad, useStyles } = useGlobalStatus();
  const styles = useStyles();
  const [infoActive, setInfoActive] = useState(false);
  const navigate = useNavigate();
  const { dispatchToast } = useToastController(TOASTER_ID);
  const [open, setOpen] = useState(false);
  const [approverEmail, setApproverEmail] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userId, setUserId] = useState(null);

  const handleInfoToggle = () => {
    document.body.classList.contains("show-tooltip") ? document.body.classList.remove('show-tooltip') : document.body.classList.add('show-tooltip');
    setInfoActive(!infoActive);
  }

  const handleDateChange = async (change) => {
    startLoad();

    const newMonthStart = change === 'previous'
    ? startOfMonth(subMonths(currentMonthStart, 1))
    : startOfMonth(addMonths(currentMonthStart, 1));

    setCurrentMonthStart(newMonthStart);
    setData(data);
    endLoad();
  };

  const handleManualDocusignApproval = async (userId, userName, approverEmail) => {
          startLoad();
          try {
              await ManualDocusignApproval(userId, currentMonthStart, approverEmail);
              showSuccessToast(dispatchToast, `Successfully sent docusign envelope for ${userName}`);
          } catch {
              showErrorToast(dispatchToast, `Failed to send docusign envelope for ${userName}`);
          }

          endLoad();
      };

  return (
    <div className="timesheet-container">
      <div className="navigation-controls">
        <TooltipWatcherWidget text="Click to go to Admin Home" direction='above'>
          <Button className={styles.buttonPrimary} onClick={() => navigate("/")}>Home</Button>
        </TooltipWatcherWidget>
        <div className="nav-center">
          <TooltipWatcherWidget text="Cycle month">
          <Button
            className={styles.buttonSecondary}
            size="large"
            icon={<ChevronLeftRegular aria-hidden="true" />}
            onClick={() => handleDateChange("previous")}
            aria-label="Go to previous month"
          >
            Prev
          </Button>
          </TooltipWatcherWidget>
          <span className="month-label" id="month-label">
            {format(currentMonthStart, "LLLL yyyy")}
          </span>
          <Button
            className={styles.buttonSecondary}
            size="large"
            icon={<ChevronRightRegular aria-hidden="true" />}
            onClick={() => handleDateChange("next")}
            aria-label="Go to next month"
          >
            Next
          </Button>
        </div>
        <Tooltip 
          withArrow
          positioning="before"
          relationship="description"
          content={{children: "Click to toggle help", className: styles.tooltip}}>
        {infoActive ? (
          <Info32Filled className="tooltip-filled" onClick={handleInfoToggle} />
        ) : (
          <Info32Regular className="tooltip" onClick={handleInfoToggle} />
        )}
      </Tooltip>
    </div>

  
      {data.map((approver, index) => (
        <div key={index} className="approver-section">
          <div className="approver-header">
            <strong className="approver-info">
              {approver.approverName} <span className="email">({approver.approverEmail})</span>
            </strong>
            <div className="approver-action" style={{marginLeft: 'auto'}}>
            </div>
          </div>
  
          <Table
            aria-label={`Approvals for ${approver.approverName}`}
            className="approval-table"
          >
            <TableHeader>
              <TableRow>
                <TableHeaderCell>User</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>DocuSign Approval</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {approver.users.map((user, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <TableCellLayout>{user.userName}</TableCellLayout>
                  </TableCell>
                  <TableCell>
                    {user.status}
                  </TableCell>
                  <TableCell>
                    <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)}>
                      <DialogTrigger disableButtonEnhancement>
                          <TooltipWatcherWidget text="Manually Send Docusign Envelope for this person" direction="above-start">
                              <Button
                              className={styles.buttonPrimary}
                              onClick={() => {setOpen(true); setApproverEmail(approver.approverEmail); setUserName(user.userName); setUserId(user.id);}}
                              >
                              Send for Approval
                              </Button>
                          </TooltipWatcherWidget>
                      </DialogTrigger>

                      <DialogSurface>
                          <DialogBody>
                          <DialogTitle>Confirmation</DialogTitle>
                          <DialogContent>Are you sure you want to generate and send a Docusign envelope to {approverEmail} for {userName}? This will take some time to run so please wait for a success message.</DialogContent>
                          <DialogActions>
                              <Button
                              className={styles.buttonPrimary}
                              onClick={() => {
                                  handleManualDocusignApproval(userId, userName, approverEmail);
                                  setOpen(false);
                              }}
                              >
                              Yes
                              </Button>
                              <Button appearance="secondary" onClick={() => setOpen(false)}>
                              No
                              </Button>
                          </DialogActions>
                          </DialogBody>
                      </DialogSurface>
                      </Dialog>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ))}
    </div>
  );
  
}
